<template>
  <div class="qysm-wrapper">
    <div class="section">
      <div
        v-for="(item, index) in items"
        :key="item.titleKey"
        :class="['wrapper', { active: activeIndex === index }]"
      >
        <div class="t_title">{{ $t(item.titleKey) }}</div>
        <div class="t_slogan">{{ $t(item.sloganKey) }}</div>
      </div>

      <a target="_blank" :href="cultureLink">
        <img class="index-qysm-btn" :src="buttonImage" :alt="$t('qysm.cultureAlt')" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QysmSection',
  computed: {
    cultureLink() {
      const currentLocale = (this.$i18n && this.$i18n.locale) ? this.$i18n.locale : 'zh-CN'
      return currentLocale === 'zh-CN' ? 'https://www.xchr-group.com/about_gyxc.html#qywh' : '/home/about-xc'
    },
    buttonImage() {
      const currentLocale = (this.$i18n && this.$i18n.locale) ? this.$i18n.locale : 'zh-CN'
      return currentLocale === 'zh-CN'
        ? require('@/static/image/index-qysm-btn.png')
        : require('@/static/image/index-enBtn.png')
    }
  },
  data() {
    return {
      activeIndex: 0,
      timer: null,
      items: [
        { titleKey: 'qysm.item1Title', sloganKey: 'qysm.item1Slogan' },
        { titleKey: 'qysm.item2Title', sloganKey: 'qysm.item2Slogan' },
        { titleKey: 'qysm.item3Title', sloganKey: 'qysm.item3Slogan' },
        { titleKey: 'qysm.item4Title', sloganKey: 'qysm.item4Slogan' },
        { titleKey: 'qysm.item5Title', sloganKey: 'qysm.item5Slogan' }
      ]
    }
  },
  mounted() {
    this.startLoop()
  },
  beforeDestroy() {
    this.clearLoop()
  },
  methods: {
    startLoop() {
      this.clearLoop()
      this.timer = setInterval(() => {
        this.activeIndex = (this.activeIndex + 1) % this.items.length
      }, 3000)
    },
    clearLoop() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    }
  }
}
</script>

<style scoped lang="scss">
.qysm-wrapper {
  background: url('~@/static/image/index-qysm.png') no-repeat;
  background-size: cover;
  width: 100%;
  height: 181px;
  background-position: center center;
  position: relative;

  .section {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    padding-top: 56px;
    position: relative;
    box-sizing: border-box;
    text-align: left;
  }

  .wrapper {
    display: none;
    width: 760px;

    &.active {
      display: block;
    }
  }

  .t_title {
    font-size: 18px;
    color: #ffffff;
    text-align: left;
  }

  .t_slogan {
    margin-top: 12px;
    font-size: 24px;
    color: #ffffff;
    line-height: 1.35;
    text-align: left;
  }

  .index-qysm-btn {
    cursor: pointer;
    position: absolute;
    top: 50%;
    width: 172px;
    height: 53px;
    right: 0;
    transform: translateY(-50%);
  }
}
</style>
